<template>
  <div>
    <div class="top-breadcrumb">
      <ol class="breadcrumb" style="background-color: white">
        <li class="breadcrumb-item" style="margin-left: 15px">
          <router-link to="" style="color: #8cc63f !important">
            Portfolio Management
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link
            style="color: #8cc63f !important"
            :to="'/' + authUser.userable_type + '/projects/accounts'"
            >Accounts</router-link
          >
        </li>
      </ol>
    </div>
    <!-- <div
      style="
        margin-top: 50px;
        display: flex;
        justify-content: end;
        padding: 0 60px;
      "
    >
      <input
        id="showHidden"
        v-model="showHidden"
        type="checkbox"
        style="height: 20px; width: 20px"
      />
      <span style="margin-left: 5px" for="showHidden"
        >Show Hidden</span
      >
    </div> -->
    <div style="display: flex; justify-content: center; margin-top: 50px">
      <md-card
        class="md-card-stats"
        style="
          background-color: white;
          max-width: 90%;
          border-radius: 15px;
          padding: 40px;
          /* margin-top: 10px; */
        "
      >
        <table style="text-align: center">
          <thead>
            <tr>
              <th>Code</th>
              <th>Investor Code</th>
              <th style="cursor: pointer" @click="toggleShowInvestorName()">
                Investor Name
              </th>
              <th style="cursor: pointer" @click="toggleShowInvestorBalance()">
                Net Balance
              </th>
              <!-- <th></th> -->
            </tr>
          </thead>
          <tbody>
            <tr v-for="(account, key) in investorAccounts" :key="key">
              <td>
                <router-link
                  style="color: black !important; font-weight: bold"
                  :to="
                    '/' +
                    authUser.userable_type +
                    '/investors/account/' +
                    account.code +
                    '/' +
                    account.id
                  "
                >
                  {{ account.code }}</router-link
                >
              </td>
              <td>{{ account.investor_details.code }}</td>
              <td v-if="showInvestorName">{{ account.investor_details.name }}</td>
              <td v-else>*********</td>
              <td v-if="showInvestorBalance">
                {{ fixNumberView(account.current_balance) }}
                {{ account.currency.code }}
              </td>
              <td v-else>*********</td>
              <!-- <td>
                <i
                  style="cursor: pointer"
                  @click="redirectToInvestorAccount(account)"
                  class="fa fa-eye"
                ></i>
              </td> -->
            </tr>
          </tbody>
        </table>
      </md-card>
    </div>
  </div>
</template><script>
import sweetAlert from "sweetalert2";
import { mapState } from "vuex";
export default {
  name: "account",
  data() {
    return {
      actionModalType: null,
      showHidden: false,
      showInvestorName: false,
      showInvestorBalance: false,
    };
  },
  components: {},
  created: function () {
    this.$store.dispatch("searchInvestorAccounts");
  },
  computed: {
    ...mapState({
      authUser: (state) => state.userStore.authUser,
      investorAccounts: (state) =>
        state.accountsStore.investorAccountSearch.investorAccounts,
      createInvestorAccountStatus: (state) =>
        state.accountsStore.investorAccountCreate.createInvestorAccountStatus,
      updateInvestorAccountStatus: (state) =>
        state.accountsStore.investorAccountUpdate.updateInvestorAccountStatus,
      deleteInvestorAccountStatus: (state) =>
        state.accountsStore.investorAccountDelete.deleteInvestorAccountStatus,
    }),
  },
  methods: {
    init() {
      this.$store.dispatch("searchInvestorAccounts");
    },
    toggleShowInvestorName() {
      this.showInvestorName = !this.showInvestorName;
    },
    toggleShowInvestorBalance() {
      this.showInvestorBalance = !this.showInvestorBalance;
    },
    fixNumberView(value) {
      const numFor = Intl.NumberFormat("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 4,
      });
      return value < 0
        ? "(" + Math.abs(value).toLocaleString() + ")"
        : numFor.format(value);
    },
    redirectToInvestorAccount(account) {
      this.$router.push(
        "/" +
          this.authUser.userable_type +
          "/investors/account/" +
          account.code +
          "/" +
          account.id
      );
    },
    filterAccounts() {},
    handleSave(account) {
      if (this.actionModalType == "createModal") {
        this.createAccount(account);
      } else {
        this.updateAccount(account);
      }
    },
    createInvestorAccount(account) {
      this.$store.dispatch("createAccount", account);
    },
    updateInvestorAccount(account) {
      this.$store.dispatch("updateAccount", account);
    },
    deleteInvestorAccount(id) {
      sweetAlert({
        title: "Confirmation",
        text: "Are you sure you want to delete this account?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.value) {
          this.$store.dispatch("deleteAccount", id);
        }
      });
    },
    toggleCreateInvestorAccountModal() {
      this.showAccountModal = !this.showAccountModal;
      this.showAccountModal ? (this.actionModalType = "createModal") : null;
    },
    toggleUpdateInvestorAccountModal(id = null) {
      this.showAccountModal = !this.showAccountModal;
      if (this.showAccountModal) {
        this.actionModalType = "updateModal";
        this.selectedAccountId = id;
      } else {
        this.actionModalType = null;
        this.selectedAccountId = null;
      }
    },
  },
  watch: {
    createInvestorAccountStatus() {
      if (this.createAccountStatus == "success") {
        sweetAlert({
          title: "Success",
          text: "Account has been created successfully",
          icon: "success",
          confirmButtonText: "Done",
        }).then(() => {
          this.init();
        });
      } else if (this.createAccountStatus == "failed") {
        sweetAlert({
          title: "Failed",
          text: "Account creation has failed",
          IntersectionObserver: "error",
          confirmButtonText: "Return",
        });
      }
    },
    updateInvestorAccountStatus() {
      if (this.updateAccountStatus == "success") {
        sweetAlert({
          title: "Success",
          text: "Account has been updated successfully",
          icon: "success",
          confirmButtonText: "Done",
        }).then(() => {
          this.init();
        });
      } else if (this.updateAccountStatus == "failed") {
        sweetAlert({
          title: "Failed",
          text: "Account update has failed",
          IntersectionObserver: "error",
          confirmButtonText: "Return",
        });
      }
    },
    deleteInvestorAccountStatus() {
      if (this.deleteAccountStatus == "success") {
        sweetAlert({
          title: "Success",
          text: "Account has been deleted successfully",
          icon: "success",
          confirmButtonText: "Done",
        }).then(() => {
          this.init();
        });
      } else if (this.deleteAccountStatus == "failed") {
        sweetAlert({
          title: "Failed",
          text: "Account delete has failed",
          IntersectionObserver: "error",
          confirmButtonText: "Return",
        });
      }
    },
  },
};
</script> 
 <style>
.md-ripple {
  padding: 0px !important;
}
.table.vgt-table {
  font-size: 20px;
}
</style>


// WEBPACK FOOTER //
// resources/js/pages/admin/investorsAccounts.vue